export default __webpack_public_path__ + "static/media/IconSharingGrey.cc8a3a42.svg";